import { render } from "./ExpandCollapse.vue?vue&type=template&id=3c394e16&scoped=true&ts=true"
import script from "./ExpandCollapse.vue?vue&type=script&lang=ts"
export * from "./ExpandCollapse.vue?vue&type=script&lang=ts"

import "./ExpandCollapse.vue?vue&type=style&index=0&id=3c394e16&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c394e16"]])

export default __exports__